export enum HubStatus {
  Connecting = 0,
  Connected = 1,
  Disconnected = 2,
}
